import React from "react"
import {applyPriceFormatter, CurrencyConfiguration} from "@next/utils"
import {TextModel} from "models/Text"
import {PriceLabel, PriceSliderLabel, StyledSliderWrapper} from "../../components"
import FacetPriceContainer from "../../facetPriceContainer"
import PriceSlider from "../../priceSlider"

interface StandardFacetsPriceProps {
    min: number
    max: number
    value: number[]
    onChange: (event: any, value: number | number[]) => void
    onChangeCommitted: (event: any, value: number | number[]) => void
    locale: string
    realm: string
    currencyCode: string
    text: TextModel
    globalPriceFormattingConfig: CurrencyConfiguration
}

const StandardFacetsPrice = ({
    min,
    max,
    value,
    onChange,
    onChangeCommitted,
    locale,
    realm,
    currencyCode,
    text,
    globalPriceFormattingConfig,
}: StandardFacetsPriceProps) => {
    const valuetext = (val: number) => `${val}`

    const marks = [
        {
            value: min,
            label: applyPriceFormatter({
                globalPriceFormattingConfig,
                minPrice: min,
                maxPrice: min,
                currencyCode,
                locale,
                realm,
            }),
        },
        {
            value: max,
            label: applyPriceFormatter({
                globalPriceFormattingConfig,
                minPrice: max,
                maxPrice: max,
                currencyCode,
                locale,
                realm,
            }),
        },
    ]

    const getAriaLabel = (idx: number) => {
        const {ariaLabelMin, ariaLabelMax} = text.pages.filters.priceFilterAriaLabels
        return idx === 0 ? ariaLabelMin : ariaLabelMax
    }

    return (
        <FacetPriceContainer>
            <PriceSliderLabel id="plp-price-slider" data-testid="plp-price-slider-label" gutterBottom>
                {text.pages.filters.priceRange}
                <PriceLabel>
                    {" "}
                    {applyPriceFormatter({
                        globalPriceFormattingConfig,
                        minPrice: value[0],
                        maxPrice: value[1],
                        currencyCode,
                        locale,
                        realm,
                    })}
                </PriceLabel>
            </PriceSliderLabel>
            <StyledSliderWrapper>
                <PriceSlider
                    data-testid="plp-price-slider"
                    min={min}
                    max={max}
                    value={value}
                    onChange={onChange}
                    onChangeCommitted={onChangeCommitted}
                    valueLabelDisplay="off"
                    getAriaValueText={valuetext}
                    step={10}
                    marks={marks}
                    getAriaLabel={getAriaLabel}
                />
            </StyledSliderWrapper>
        </FacetPriceContainer>
    )
}

export default StandardFacetsPrice
